<template>
  <div class="application-form-type">
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-form-group label="Fördermassnahme">
      <b-form-select v-model="calculatorType" :options="calculatorTypes">
        <template v-slot:first>
          <b-form-select-option :value="null">Massnahme auswählen</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      hasUnknownError: false,
      unknownErrorMessage: '',
      calculatorTypes: []
    }),
    created () {
      this.getCalculatorTypes()
    },
    methods: {
      async getCalculatorTypes () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('calculator/GET_CALCULATOR_TYPES').then(res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const calculatorTypes = data.calculatorApplicationTypes

          const renamedTypes = calculatorTypes.map(type => ({
            text: type.bezeichnung,
            abkuerzung: type.abkuerzung,
            value: type.abkuerzung
          }))

          this.calculatorTypes = renamedTypes
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      }
    },
    computed: {
      ...mapState({
        communityId: state => state.calculator.communityId
      }),
      calculatorType: {
        set (value) {
          this.$store.commit('calculator/SET_CALCULATOR_TYPE', value)
        },
        get () {
          return this.$store.state.calculator.calculatorType
        }
      }
    },
    watch: {
      communityId (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getCalculatorTypes()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .application-form-type::v-deep{
    legend{
      padding-top: 0;
      padding-bottom: .2rem;
      margin-bottom: 0;
      color: #878787;
    }
  }
</style>
